import { AfterViewInit, Component, OnInit } from "@angular/core";
import { AppService } from "src/app/global/services/app.service";
// import PerfectScrollbar from 'perfect-scrollbar';

declare const $: any;

//Metadata
export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  icontype: string;
  collapse?: string;
  children?: ChildrenItems[];
  permissions?: string[];
}

export interface ChildrenItems {
  path: string;
  title: string;
  ab: string;
  type?: string;
  permissions?: string[];
}

//Menu Items
export var ROUTES: RouteInfo[] = [
  {
    path: "/dashboard",
    title: "SideMenu.Dashboard",
    type: "link",
    icontype: "home",
  },
  {
    path: "/purchasing",
    title: "SideMenu.Purchasing.Title",
    type: "link",
    icontype: "store",
    collapse: "purchasing",
    permissions: ["purchasingDashboard.view"],
    children: [
      {
        path: "requisition",
        title: "Purchasing.Menu.Requisition.Title",
        ab: "",
      },
      {
        path: "purchase-order",
        title: "Purchasing.Menu.Purchase.Title",
        ab: "",
      },
      {
        path: "payment-request",
        title: "Purchasing.Menu.Payment-Request.Title",
        ab: "",
      },
      { path: "product", title: "Purchasing.Menu.Products.Title", ab: "" },
      {
        path: "purchasing-suppliers",
        title: "Purchasing.Menu.Suppliers.Title",
        ab: "",
      },
      {
        path: "suppliers-catalog",
        title: "Purchasing.Menu.Suppliers-Catalog.Title",
        ab: "",
      },
    ],
  },
  {
    path: "/catalogs",
    title: "SideMenu.Catalogs.Title",
    type: "sub",
    icontype: "folder",
    collapse: "catalogs",
    permissions: [
      "users.view",
      "roles.view",
      "shelters.view",
      "suppliers.view",
      "corporates.view",
      "corporate-departments.view",
      "corporate-accounts.view",
      "corporate-plants.view",
      "plants-areas.view",
      "authlevels.view",
      "units-of-measure-catalog.view",
      "exchange-rate-catalog.view",
      "useCFDI.view",
    ],
    children: [
      {
        path: "users",
        title: "SideMenu.User-Management.Users.Title",
        ab: "SideMenu.User-Management.Users.Short",
        permissions: ["users.view"],
      },
      {
        path: "roles",
        title: "SideMenu.User-Management.Roles.Title",
        ab: "SideMenu.User-Management.Roles.Short",
        permissions: ["roles.view"],
      },
      {
        path: "shelters",
        title: "SideMenu.Shelter-Management.Shelters.Title",
        ab: "SideMenu.Shelter-Management.Shelters.Short",
        permissions: ["shelters.view"],
      },
      {
        path: "suppliers",
        title: "SideMenu.Shelter-Management.Suppliers.Title",
        ab: "SideMenu.Shelter-Management.Suppliers.Short",
        permissions: ["suppliers.view"],
      },
      {
        path: "corporates",
        title: "SideMenu.Corporate-Management.Corporates.Title",
        ab: "SideMenu.Corporate-Management.Corporates.Short",
        permissions: ["corporates.view"],
      },
      {
        path: "corporates-departments",
        title: "SideMenu.Corporate-Management.Departments.Title",
        ab: "SideMenu.Corporate-Management.Departments.Short",
        permissions: ["corporate-departments.view"],
      },
      {
        path: "corporates-accounts",
        title: "SideMenu.Corporate-Management.Accounts.Title",
        ab: "SideMenu.Corporate-Management.Accounts.Short",
        permissions: ["corporate-accounts.view"],
      },
      {
        path: "corporates-plants",
        title: "SideMenu.Corporate-Management.Plants.Title",
        ab: "SideMenu.Corporate-Management.Plants.Short",
        permissions: ["corporate-plants.view"],
      },
      {
        path: "corporates-plants-areas",
        title: "SideMenu.Corporate-Management.Areas.Title",
        ab: "SideMenu.Corporate-Management.Areas.Short",
        permissions: ["plants-areas.view"],
      },
      {
        path: "auth-levels",
        title: "SideMenu.Corporate-Management.AuthLevels.Title",
        ab: "SideMenu.Corporate-Management.AuthLevels.Short",
        permissions: ["authlevels.view"],
      },
      {
        path: "tax",
        title: "SideMenu.Tax.Title",
        ab: "SideMenu.Tax.Short",
        permissions: ["taxesCatalog.view"],
      },
      {
        path: "exchange-rate",
        title: "SideMenu.ExchangeType.Title",
        ab: "SideMenu.ExchangeType.Short",
        permissions: ["exchange-rate-catalog.view"],
      },
      {
        path: "units-of-measure",
        title: "SideMenu.UnitsOfMeasure.Title",
        ab: "SideMenu.UnitsOfMeasure.Short",
        permissions: ["units-of-measure-catalog.view"],
      },
      {
        path: "cfdi-usage",
        title: "modules.catalogs.pages.CFDI.title",
        ab: "modules.catalogs.pages.CFDI.letter",
        permissions: ["useCFDI.view"],
      },
      // {
      //   path: "reportspayroll",
      //   title: "SideMenu.PayrollReports.Title",
      //   ab: "SideMenu.PayrollReports.Short",
      // },
    ],
  },
  {
    path: "/debts-to-pay",
    title: "SideMenu.AccountsPayable.Title",
    type: "link",
    icontype: "paid",
    permissions: ["debtsToPayDashboard.view"],
    children: [
      { path: "debts", title: "Accounts-Payable.Title", ab: "" },
      { path: "invoice-debts", title: "Accounts-Payable.Invoices", ab: "" },
      { path: "against-receipt-debts", title: "Accounts-Payable.CR", ab: "" },
      { path: "payment-request-debts", title: "Accounts-Payable.PR", ab: "" },
    ],
  },
  {
    path: "/invoicing",
    title: "SideMenu.Invoicing.Title",
    type: "link",
    icontype: "receipt",
    permissions: ["invoicingDashboard.view"],
    children: [
      { path: "memo", title: "Invoicing.M", ab: "" },
      { path: "payroll", title: "Invoicing.PR", ab: "" },
      { path: "internal-invoice", title: "Invoicing.FI", ab: "" },
      { path: "invoice-package", title: "Invoicing.PF", ab: "" },
      { path: "payments", title: "Invoicing.P", ab: "" },
    ],
  },
  {
    path: "/clients",
    title: "SideMenu.Clients.Title",
    type: "link",
    icontype: "business",
    permissions: ["customerDashboard.view"],
    children: [
      { path: "account-status", title: "Clients.AccountStatus", ab: "" },
      { path: "weekly-billing", title: "Clients.WeeklyBilling", ab: "" },
    ],
  },
  {
    path: "/suppliers",
    title: "SideMenu.Suppliers.Title",
    type: "link",
    icontype: "local_shipping",
    permissions: ["suppliersDashboard.view"],
    children: [
      { path: "purchase-order", title: "Suppliers.PurchaseOrders", ab: "" },
      {
        path: "counter-receipt",
        title: "Suppliers.CounterReceipts.Title",
        ab: "",
      },
      { path: "invoices", title: "Suppliers.Invoice.Title", ab: "" },
    ],
  },
  {
    path: "/repse",
    title: "SideMenu.Repse.Title",
    type: "sub",
    icontype: "verified_user",
    collapse: "repse",
    permissions: ["repseDashboard.view"],
    children: [
      {
        path: "admin-documents",
        title: "REPSE.AdminDocuments",
        ab: "-",
        permissions: ["repseAdmin.view"],
      },
      {
        path: "upload-documents",
        title: "REPSE.UploadDocuments",
        ab: "-",
        permissions: ["repseUpload.view"],
      },
      {
        path: "query-documents",
        title: "REPSE.QueryDocuments",
        ab: "-",
        permissions: ["repseQuery.view"],
      },
      {
        path: "document-status",
        title: "REPSE.DocumentStatus",
        ab: "-",
        permissions: ["repseStatus.view"],
      },
    ],
  },
  {
    path: "/reports",
    title: "SideMenu.Reports.Title",
    type: "sub",
    icontype: "find_in_page",
    collapse: "reports",
    permissions: ["reportsDashboard.view"],
    children: [
      {
        path: "tax",
        title: "modules.reports.reporttax.title",
        ab: "R",
        permissions: ["history.view"],
      },
      {
        path: "purchaseorders",
        title: "modules.reports.purchaseorder.title",
        ab: "R",
        permissions: ["history.view"],
      },
      {
        path: "purchaseordersProduct",
        title: "modules.reports.purchaseorderproduct.title",
        ab: "R",
        permissions: ["history.view"],
      },
      {
        path: "paymentrequest",
        title: "modules.reports.paymentrequest.title",
        ab: "R",
        permissions: ["history.view"],
      },
      {
        path: "invoicing",
        title: "modules.reports.invoicing.title",
        ab: "R",
        permissions: ["history.view"],
      },
      {
        path: "invoicependingpaid",
        title: "modules.reports.invoicependingpaid.title",
        ab: "R",
        permissions: ["history.view"],
      },
    ],
  },
];

@Component({
  selector: "app-sidebar-cmp",
  templateUrl: "sidebar.component.html",
})
export class SidebarComponent implements OnInit, AfterViewInit {
  ShowNavigation: boolean = true;
  ShowNavigationToClient: boolean = true;

  public menuItems: any[];
  ps: any;

  constructor(private _appService: AppService) {
    /*if(this.ShowNavigation){
            this.ShowNavigation = true;
            this.ShowNavigationToClient = true;
        }else if(this._appService.UserLogin.roleID == 55){//Validar usuario de tipo CLIENTE
            this.ShowNavigation = false;
            this.ShowNavigationToClient = true;
        }else{
            this.ShowNavigation = true;
            this.ShowNavigationToClient = false;
        }*/
  }

  ngAfterViewInit(): void {
    if (
      this._appService.UserLogin.type == this._appService.EUserTypes.CORPORATIVO
    ) {
      this.ShowNavigationToClient = true;
      this.ShowNavigation = false;
    } else {
      this.ShowNavigationToClient = false;
      this.ShowNavigation = true;
    }
  }

  ngOnInit() {
    this.menuItems = ROUTES.filter((menuItem) => menuItem);
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      const elemSidebar = <HTMLElement>(
        document.querySelector(".sidebar .sidebar-wrapper")
      );
      // this.ps = new PerfectScrollbar(elemSidebar);
    }
  }
  updatePS(): void {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      this.ps.update();
    }
  }
  isMac(): boolean {
    let bool = false;
    if (
      navigator.platform.toUpperCase().indexOf("MAC") >= 0 ||
      navigator.platform.toUpperCase().indexOf("IPAD") >= 0
    ) {
      bool = true;
    }
    return bool;
  }
}
